<template>
  <form @submit.prevent="submit">
    <div class="mb-3">
      <label class="va-input__label">Дата</label>
      <input v-model="form.date" type="date" class="form-control" required />
      <span v-if="errors.date" class="error-message">{{ errors.date }}</span>
    </div>
    <div class="mb-3">
      <label class="va-input__label">Слот</label>
      <select
        v-model="form.delivery_slot_id"
        class="form-control"
        :class="{ 'form-control--error': errors.delivery_slot_id }"
      >
        <option value="">Выберите слот</option>
        <option
          v-for="opt in slotSelectOptions"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.text }}
        </option>
      </select>
      <span v-if="errors.delivery_slot_id" class="error-message">{{
        errors.delivery_slot_id
      }}</span>
    </div>
    <va-checkbox v-model="form.is_available" label="Доступен" class="mb-4" />
    <div class="d-flex gap-2">
      <va-button type="submit" color="primary">Сохранить</va-button>
      <va-button type="button" @click="$emit('cancel')">Отмена</va-button>
    </div>
  </form>
</template>

<script>
export default {
  name: "DeliverySlotExceptionForm",
  props: {
    initial: { type: Object, default: null },
    slots: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {
        date: "",
        delivery_slot_id: "",
        is_available: false,
      },
      errors: {},
    };
  },
  computed: {
    slotSelectOptions() {
      const list = this.slots || [];
      return list
        .filter((o) => o.value != null && o.value !== "")
        .map((o) => ({
          value: Number(o.value),
          text: o.text || String(o.value),
        }));
    },
  },
  watch: {
    initial: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = {
            date: String(val.date || "").substring(0, 10),
            delivery_slot_id:
              val.delivery_slot_id != null && val.delivery_slot_id !== ""
                ? Number(val.delivery_slot_id)
                : "",
            is_available: !!val.is_available,
          };
        } else {
          this.form = {
            date: "",
            delivery_slot_id: "",
            is_available: false,
          };
        }
        this.errors = {};
      },
    },
  },
  methods: {
    validate() {
      this.errors = {};
      if (!this.form.date) this.errors.date = "Обязательное поле";
      if (
        this.form.delivery_slot_id === "" ||
        this.form.delivery_slot_id == null
      ) {
        this.errors.delivery_slot_id = "Выберите слот";
      }
      return Object.keys(this.errors).length === 0;
    },
    submit() {
      if (!this.validate()) return;
      this.$emit("submit", {
        date: this.form.date,
        delivery_slot_id: Number(this.form.delivery_slot_id),
        is_available: this.form.is_available,
      });
    },
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.form-control--error {
  border-color: #e34a4a;
}
.error-message {
  color: #e34a4a;
  font-size: 0.875rem;
}
</style>
